"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Observable = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Observable = exports.Observable = /*#__PURE__*/function () {
  function Observable(object) {
    _classCallCheck(this, Observable);
    _defineProperty(this, "_eventListeners", []);
    _defineProperty(this, "_object", null);
    this._object = object;
    /*
    , inject = ['on', 'off', 'dispatch']
    if (inject && (inject instanceof Array)) {
        for (let m of inject) {
            object[m] = this[m].bind(this);
        }
    }
    */
  }
  _createClass(Observable, [{
    key: "on",
    value: function on(eventName, callback) {
      var _this = this;
      if (this.indexOf(eventName, callback) !== -1) {
        // eslint-disable-next-line no-console
        console.warn("The following callback is already added to the event: ".concat(eventName), callback);
        return;
      }
      this._eventListeners.push({
        eventName: eventName,
        callback: callback
      });
      return function () {
        return _this.off(eventName, callback);
      };
    }
  }, {
    key: "off",
    value: function off(eventName, callback) {
      var idx = this.indexOf(eventName, callback);
      if (idx !== -1) {
        this._eventListeners.splice(idx, 1);
      }
    }
  }, {
    key: "indexOf",
    value: function indexOf(eventName, callback) {
      for (var o = 0; o < this._eventListeners.length; o++) {
        var el = this._eventListeners[o];
        if (el.eventName === eventName && el.callback === callback) {
          return o;
        }
      }
      return -1;
    }
  }, {
    key: "dispatch",
    value: function dispatch(eventName, params) {
      var direct = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var notify = this.createNotifyFunction(eventName, params);
      if (direct) {
        notify();
      } else {
        setTimeout(notify);
      }
    }
  }, {
    key: "createNotifyFunction",
    value: function createNotifyFunction(eventName, params) {
      var _this2 = this;
      return function () {
        var _iterator = _createForOfIteratorHelper(_this2._eventListeners),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var el = _step.value;
            if (el.eventName === eventName) {
              el.callback.call(_this2._object, {
                eventName: eventName,
                time: new Date(),
                data: params
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._eventListeners = [];
      this._object = undefined;
    }
  }]);
  return Observable;
}();
var _default = exports["default"] = Observable;